import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneInput.scss";

const PhoneFormInput = ({
  label,
  divClassName,
  name,
  value,
  handleBlur,
  error,
  touched,
  setFieldValue,
  placeholder,
  inputClass,
  containerClass,
  buttonClass,
  labelClass,
  inputStyle,
  buttonStyle,
  errorClass,
  ...rest
}) => {
  const [dialCode, setDialCode] = React.useState("61");

  const handleInputChange = (phoneNumber, data) => {
    if (data && data.dialCode) {
      setDialCode(data.dialCode);
    }
    setFieldValue(name, phoneNumber);
  };

  return (
    <div className={divClassName}>
      {label && (
        <p className={`${labelClass || "mb-2 text-sm font-medium text-gray-700"}`}>
          {label}
        </p>
      )}
      <div className="relative">
        <PhoneInput
          country={"au"}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          enableSearch={false}
          disableSearchIcon={true}
          disableCountryCode={false}
          inputProps={{
            name: name,
            placeholder: placeholder || "Contact Number",
            ...rest
          }}
          placeholder={placeholder || "Contact Number"}
          containerClass={containerClass || "react-tel-input"}
          inputClass={inputClass || "form-control"}
          buttonClass={buttonClass || "flag-dropdown"}
          dropdownClass="country-list"
          inputStyle={{
            ...inputStyle
          }}
          buttonStyle={buttonStyle}
        />
      </div>
      {error && touched ? (
        <span className={errorClass || "text-red-600 text-[12px] sm:text-[13px] md:text-[14px] font-[500] ms-1"}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default PhoneFormInput;
